import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withTranslation } from 'react-i18next';

import SizeNameCell from './SizeNameCell';

class SizeNameRow extends React.Component {
  render() {
    const {
      dish,
      typeSizes,
      dishSizes,
      handleSizeNameChange,
      type,
      t,
      copyMode,
    } = this.props;

    return (
      <TableRow>
        <TableCell>
          {t('mealTypes.nameForSize', 'Nazwa dla rozmiaru')}
        </TableCell>
        <TableCell />
        <TableCell />
        {typeSizes.map((size, sizeKey) => (
          <SizeNameCell
            key={`${type['@id']}_${sizeKey}`}
            dish={dish}
            size={size.size}
            dishSizes={dishSizes}
            handleSizeNameChange={handleSizeNameChange}
            copyMode={copyMode}
          />
        ))}
      </TableRow>
    );
  }
}

export default withTranslation()(SizeNameRow);
